import api from '@app/api/api';

const controller = 'crfTap';

export interface TapJoinProjeto {
  projetoId: string;
  cicloOrcamentarioId: string;
}

export interface TapCicloOrcamentarioHasJoinProjeto {
  tapId: string;
  tapAreaId: string;
  tapDepartamentoId: string;
  tapDiretoriaId: string;
  tapEscopoAnual: string;
  nomeArea: string;
  nomeDepartamento: string;
  nomeDiretoria: string;
  tapIdFinplan: number;
  tapAno: number;
}

export const getAllTapHasJoinProjeto = (join: TapJoinProjeto) =>
  api.get<TapCicloOrcamentarioHasJoinProjeto[]>(`${controller}/tapHasJoinProjeto/${join.projetoId}`);

export const updateTap = (tap: TapCicloOrcamentarioHasJoinProjeto) =>
  api.put<TapCicloOrcamentarioHasJoinProjeto>(`${controller}/${tap.tapId}`, tap);
